import React from 'react';
import ReactDOM from "react-dom/client";
import App from './App';
import '@css/gl.scss'
import "animate.css";
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);
// 设置中文环境
dayjs.locale('zh-cn');
dayjs.tz.setDefault("Asia/Shanghai");

import global from "@public/Global";
//echarts.registerTheme('customed', customed)


// 使用 createRoot 创建一个 root
const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);
(()=>{
    let [search='']=window.location.hash.match(/\?(.*)$/)||[];
    const params = new URLSearchParams(search);
    const searchParams = new URLSearchParams(window.location.search);
    if(params.get('token')&&!searchParams.get('token')){
        console.log(search,search)
        window.location.search=search;
    }

})()
// 渲染应用
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
